import React from 'react';
import styled from 'styled-components';
import { Divider, Typography } from '@beeline.com/bp-design-system';
import { MultiEngagement } from './MultiEngagement/MultiEngagement';
import { useEngagementsGeneralIntl } from './translations/useEngagementsGeneralIntl';
import { EngagementStatus } from './EngagementStatus/EngagementStatus';

export const EngagementsGeneral: React.FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useEngagementsGeneralIntl();

  return (
    <StyledEngagementsGeneral>
      <Typography variant="h2">{intl.general}</Typography>
      <Typography variant="body1">{intl.generalSettingsEngagementDataFunctionalities}</Typography>
      <MultiEngagement />
      <StyledDivider />
      <EngagementStatus />
    </StyledEngagementsGeneral>
  );
};

const StyledEngagementsGeneral = styled.div`
  padding: 0 1rem;
`;

const StyledDivider = styled(Divider)`
  && {
    margin-top: 2rem;
  }
`;
